import { useEffect, useState } from 'react'
import { type AxiosError } from 'axios'
import { logger } from 'shared/lib'
import { type IResponseTemplate } from 'entities/AICalling/api/types'
import { AiCallingApi } from 'entities/AICalling/api/aiCallingApi'
import { cacheStore } from 'entities/Cache/CacheStore'

export function useGetAgentCallingTemplates() {
  const [templates, setTemplates] = useState<IResponseTemplate[] | null>(
    cacheStore.getData<IResponseTemplate[]>('AiCallingApi.getTemplates') || null
  )
  const [loading, setLoading] = useState(!templates)
  const [error, setError] = useState<AxiosError | null>(null)

  useEffect(() => {
    if (!templates) {
      AiCallingApi.getTemplates()
        .then(({ data }) => {
          cacheStore.setData<IResponseTemplate[]>('AiCallingApi.getTemplates', data)
          setTemplates(data)
        })
        .catch((e) => {
          setError(e)
          logger.error(e)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])
  return [templates, loading, error] as const
}
